import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { WHY } from "@/data/content";

export default function About() {
  return (
    <div>
      <PageHeader
        overline="About"
        title="We design websites that work as hard as you do."
        subtitle="Kenny Web Design is a premium studio helping local businesses, startups, and established brands turn their websites into their best sales tool."
      />

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-7">
            <h2 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">Our story</h2>
            <div className="mt-6 space-y-5 text-zinc-600 leading-relaxed text-lg">
              <p>
                At Kenny Web Design, it all started with a simple question: "Why doesn't this place have a website?"
                After too many visits to local restaurants without an online menu or an easy way to learn more about
                their business, Kenny and his roommate, Isaiah, saw an opportunity to help.
              </p>
              <p>
                What began as a way to support local businesses in Newport News, Virginia, quickly grew into a passion
                for creating modern, professional websites that help businesses stand out online.
              </p>
              <p>
                Today, we're proud to serve our community by building clean, user-friendly websites that make it easier
                for customers to discover, trust, and connect with the businesses that make our area special.
              </p>
            </div>
          </Reveal>
          <div className="lg:col-span-5">
            <div className="border border-black/10 bg-white p-8 sm:p-10">
              <span className="text-[11px] uppercase tracking-[0.2em] text-zinc-400">Why choose us</span>
              <ul className="mt-6 space-y-3">
                {WHY.map((w) => (
                  <li key={w} className="flex items-center gap-3 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-black" /> {w}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 text-center">
        <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">Let's build something great.</h2>
        <Link to="/contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-black text-white font-medium px-7 py-4 hover:bg-zinc-800 transition-colors">
          Get a Free Consultation <ArrowRight size={18} />
        </Link>
      </section>
    </div>
  );
}
